export default function StickyCTA() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 pb-3 sm:pb-4">
        <div className="bg-white/95 backdrop-blur-xl rounded-2xl shadow-2xl border-t border-gray-100 overflow-hidden">
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-2 sm:gap-4 px-4 sm:px-6 py-3 sm:py-4">
            <div className="flex-1 text-center sm:text-left">
              <p className="text-sm sm:text-base font-bold text-ink-900 mb-0.5 sm:mb-1">
                Klaar voor een nieuwe vloer?
              </p>
              <p className="text-xs sm:text-sm text-ink-600">
                Ontvang binnen 24 uur een vrijblijvende offerte voor jouw vloer
              </p>
            </div>
            <a
              href="#offerte"
              className="inline-flex items-center justify-center gap-2 bg-brass-500 hover:bg-brass-600 text-white px-5 sm:px-8 py-2.5 sm:py-3.5 rounded-xl font-semibold text-sm sm:text-base hover:shadow-lg transition-all duration-300 whitespace-nowrap flex-shrink-0"
            >
              Gratis Offerte
              <i className="ri-arrow-right-line text-base sm:text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}